module.exports = __webpack_public_path__ + "img/doctor.587074aa.png";